






















































import Vue from 'vue'
import _ from 'lodash'
import { Color, LanguageRow } from '@/types'
import ColorPicker from '@/components/ColorPicker.vue'
import PlanningGroupsDialog from '@/components/settings/PlanningGroupsDialog.vue'
import { CreatePlanningGroup, CompanyInsertPlanningGroupPayload } from '@/types/payload'
import { COMPANY_INSERT_PLANNING_GROUP, FETCH_PLANNING_GROUP_LIST } from '@/store/action-types'
import { PlanningGroupsSettings } from '@/model/settings/PlanningGroupsSettings'
import { PlanningGroupsList } from '@/model/settings/PlanningGroupsList'

interface ComponentData {
  allPlanningGroups: Array<PlanningGroupsList>
  languageRows: Array<LanguageRow>
  showPlanningGroupsDialog: boolean
  eventValidationRules: Array<Function>
  selectedPlanningGroupId: number | null
  selectedPlanningGroup: PlanningGroupsSettings | undefined
  planningGroupColor: string | null
  isSelectionEnabled: boolean
  saveButtonLoading: boolean
}

export default Vue.extend({
  name: 'PlanningGroupsSettingsDialog',

  components: {
    ColorPicker,
    PlanningGroupsDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    planningGroup: {
      type: Object as () => PlanningGroupsSettings
    },
    loading: Boolean,
    allCreatedGroups: {
      type: Array as ()=> Array<PlanningGroupsSettings>
    }
  },

  computed: {
    filteredGroup (): Array<PlanningGroupsList> {
      const createdGroupsIds: Array<number> = this.allCreatedGroups.map((item: PlanningGroupsSettings) => {
        return item.planningGroupId
      })
      const filteredGroups: Array<PlanningGroupsList> = _.filter(this.allPlanningGroups, (i: PlanningGroupsList) => !_.includes(createdGroupsIds, i.id))

      return filteredGroups
    }
  },

  watch: {
    show (newVal: boolean) {
      if (newVal && this.planningGroup) {
        this.selectedPlanningGroup = _.cloneDeep(this.planningGroup)
        this.selectedPlanningGroupId = this.selectedPlanningGroup.planningGroupId
        this.planningGroupColor = this.selectedPlanningGroup.color
        this.isSelectionEnabled = true
      } else {
        this.resetForm()
      }
    }
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      allPlanningGroups: [],
      languageRows: [],
      showPlanningGroupsDialog: false,
      eventValidationRules: [
        required
      ],
      selectedPlanningGroupId: null,
      selectedPlanningGroup: undefined,
      planningGroupColor: '#fff',
      isSelectionEnabled: false,
      saveButtonLoading: false
    }
  },

  methods: {

    createPlanningGroup (): void {
      this.showPlanningGroupsDialog = true
    },

    onPlanningGroupsDialogClose (): void {
      this.showPlanningGroupsDialog = false
    },

    async onPlanningGroupsDialogSave (languageRows: Array<LanguageRow>): Promise<void> {
      const payloadLanguages: CompanyInsertPlanningGroupPayload = {
        languageRows: languageRows
      }
      try {
        this.saveButtonLoading = true
        await this.$store.dispatch(COMPANY_INSERT_PLANNING_GROUP, payloadLanguages)
        this.saveButtonLoading = false
        this.showPlanningGroupsDialog = false
        this.fetchPlanningGroupsList()
      } catch (e) {
        this.saveButtonLoading = false
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        const payload: CreatePlanningGroup = {
          action: '',
          departmentId: null,
          planningGroupId: this.selectedPlanningGroupId ? this.selectedPlanningGroupId : null,
          color: this.planningGroupColor ? this.planningGroupColor.replace('#', '') : 'fff',
          id: null,
        }
        this.$emit('save', payload)
      }
    },

    resetForm (): void {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }

      this.selectedPlanningGroupId = null
      this.selectedPlanningGroup = undefined
      this.planningGroupColor = '#fff'
      this.isSelectionEnabled = false

    },

    onColorChange (color: Color): void {
      if (color && color.hex) {
        this.planningGroupColor = color.hex
      }
    },

    async fetchPlanningGroupsList (): Promise<void> {
      const data: Array<PlanningGroupsList> = await this.$store.dispatch(FETCH_PLANNING_GROUP_LIST)
      this.allPlanningGroups = data
    }
  },

  async mounted () {
    this.fetchPlanningGroupsList()
  }

})
